module.exports = __webpack_public_path__ + "media/images/vector/texture-bc8300fe7b22d102cf1dfb83914df6a9.png";